import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import BasicInput from '../../../../../../components/BasicInput';

const InputField = props => {
  const {
    value,
    name,
    required,
    labelText,
    placeholder,
    isValid,
    onChange,
    onBlur,
  } = props;

  return (
    <div className="form__group form__group--compact">
      <BasicInput
        name={name}
        content={value}
        isValid={isValid}
        label={labelText}
        placeholder={placeholder}
        required={required}
        inputType="email"
        controlFunc={onChange}
        touchFunc={onBlur}
        labelStyles={{ fontWeight: 'bold' }}
      />

      <ErrorMessage
        name={name}
        render={message => <div className="form__error">{message}</div>}
      />
    </div>
  );
};

InputField.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default InputField;
